import React from 'react';

import classes from './PageItem.module.scss';
import { NavigationIconType } from '../../../../constants/system/navigationIcons';
import { getNavigationIcon } from '../../../../utils/navigationUtils/getNavigationIcon/getNavigationIcon';

export type PageItemProps = {
  title: string;
  icon: NavigationIconType;
};

const PageItem = ({ icon, title }: PageItemProps) => {
  return (
    <div className={classes.container}>
      {getNavigationIcon(icon)}
      <p>{title}</p>
    </div>
  );
};

export { PageItem };
